import toast from 'react-hot-toast';
import { useRef, useCallback } from 'react';

interface UseShowSingleToastReturn {
  showSingleToast: (
    ...toastDotCustomArgs: Parameters<typeof toast.custom>
  ) => void;
}

/**
 * Light helper method to ensure only a single toast from a set is shown at once
 */
const useShowSingleToast = (): UseShowSingleToastReturn => {
  const toastRef = useRef<string | null>(null);

  const showSingleToast = useCallback(
    (...toastDotCustomArgs: Parameters<typeof toast.custom>) => {
      if (toastRef.current) {
        toast.remove(toastRef.current);
      }

      toastRef.current = toast.custom(...toastDotCustomArgs);
    },
    []
  );

  return {
    showSingleToast,
  };
};

export default useShowSingleToast;
